<template>
  <swiper
    :slidesPerView="1"
    :spaceBetween="30"
    :pagination="{
      clickable: true,
    }"
    :navigation="true"
    :modules="modules"
    class="mySwiper"
    :autoplay="{
      delay: 3500,
      disableOnInteraction: false,
    }"
  >
    <swiper-slide>
      <img
        src="../assets/karussellHotel1.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellHotel2.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellHotel3.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellHotel4.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
  </swiper>
</template>

<!-- 
HILFE !!
https://swiperjs.com/demos#effect-fade 
-->

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "../../assets/mySwiper.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { openModal } from "jenesius-vue-modal";
import ModalPic from "../components/Modals/ModalPic.vue";

export default {
  name: "karussellAktuelles1",
  components: {
    Swiper,
    SwiperSlide,
  },

  methods: {
    async openPic(pic) {
      if (window.innerWidth >= 768) {
        const props = { adressePic: pic };
        const modal = await openModal(ModalPic, props);
        modal.onclose = () => {
          return true;
        };
      }
    },
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
